/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { withRouter } from 'react-router-dom';
import styles from '../envImpairment.module.scss';
import './MaterialsWasteAndTransComponent.messages';
import metadata from './MaterialsWasteAndTransComponent.metadata.json5';
import RawMaterialsDisposalsComponent from '../RawMaterialsDisposals/RawMaterialsDisposalsComponent'

function MaterialsWasteAndTransComponent(props) {

    const { submissionVM, pathUpdated, updateWizardData } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('MaterialsWasteAndTransComponent');
    const viewModelService = useContext(ViewModelServiceContext);
    const modelVM = _.get(submissionVM, pathUpdated)
    const [selectedRawMaterials, setSelectedRawMaterials] = useState(-1)

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const addMaterialsWasteTransInformation = useCallback(async () => {

        const materialsWasteTransVal = submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value

        const materialsWasteTransObj = {
            rawMat1: materialsWasteTransVal.length === 0 ? 1 : EntityUtil.nextId(),
            isValidationReq: true
        };

        const { _xCenter, _dtoName } = submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO;

        const materialHandlingInformationVM = viewModelService.create(materialsWasteTransObj, _xCenter, _dtoName);

        submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value = submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value || []

        submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.pushElement(
            materialHandlingInformationVM
        );
        setSelectedRawMaterials(submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.length - 1)
        updateWizardData(submissionVM);
    },
        [submissionVM, viewModelService, updateWizardData]
    );

    const informationOverrides = useMemo(() => {
        const informationList = _.get(submissionVM, 'lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO', []);
        let overrides = '';

        if (!_.isEmpty(informationList)) {
            overrides = informationList?.children.map((information, index) => ({
                [`rawMaterialsDisposalsComponent${index}`]: {
                    overrideProps: {
                        "@field": {
                            // apply to all fields
                            showRequired: true,
                            labelPosition: "left",
                        },
                    },
                    submissionVM,
                    updateWizardData,
                    pathUpdated: `lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.children[${index}]`,
                    informationVm: information,
                    index,
                    viewModelService,
                    selectedRawMaterials
                },
            }));
        }

        return Object.assign({}, ...overrides);
    }, [selectedRawMaterials, submissionVM, updateWizardData, viewModelService]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },

        ...informationOverrides,
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            addMaterialsWasteTransInformation
        },
        resolveComponentMap: {
            rawMaterialsDisposalsComponent: RawMaterialsDisposalsComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );

}

MaterialsWasteAndTransComponent.propTypes = wizardProps;
export default withRouter(MaterialsWasteAndTransComponent);
